import request from '@/config/axios'

export interface BossCircleHomeFeatureVO {
  id?: number
  groupCode: string
  featureCode?: string
  name: string
  iconUrl?: string
  path: string
  needLogin: boolean
  sort: number
  status: number
  createTime?: string
}

export interface BossCircleFeatureOption {
  code: string
  name: string
  label: string
  path: string
  needLogin?: boolean
  developing?: boolean
}

export const getHomeFeatureList = (groupCode?: string) =>
  request.get({ url: '/bosscircle/home-feature/list', params: { groupCode } })

/** Boss 圈功能目录，后台跳转下拉的数据源 */
export const getHomeFeatureCatalog = () =>
  request.get({ url: '/bosscircle/home-feature/catalog' })

export const createHomeFeature = (data: BossCircleHomeFeatureVO) =>
  request.post({ url: '/bosscircle/home-feature/create', data })

export const updateHomeFeature = (data: BossCircleHomeFeatureVO) =>
  request.put({ url: '/bosscircle/home-feature/update', data })

export const deleteHomeFeature = (id: number) =>
  request.delete({ url: '/bosscircle/home-feature/delete', params: { id } })
